/**
 * Generated from SceneCreatorSceneLayout.fla
 */
export function SceneCreatorSceneLayout(this: ISceneCreatorSceneLayout) {
	let sceneDefault = this.sceneDefault;
	SceneCreatorSceneLayout_sceneDefault.call(this.sceneDefault);
	sceneDefault.x = 0;
	sceneDefault.y = 0;
	if (sceneDefault.onLayout) sceneDefault.onLayout();
	return this;
}
export function SceneCreatorSceneLayout_sceneDefault(this: ISceneCreatorSceneLayout_sceneDefault) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"slot":"decorationLeft"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_slotDecorationLeft.call(items[0] as ISceneCreatorSceneLayout_slotDecorationLeft);
		(items[0] as ISceneCreatorSceneLayout_slotDecorationLeft).slot = "decorationLeft";
		items[0].x = 511.4;
		items[0].y = 998.85;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"slot":"decorationRight"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_slotDecorationRight.call(items[1] as ISceneCreatorSceneLayout_slotDecorationRight);
		(items[1] as ISceneCreatorSceneLayout_slotDecorationRight).slot = "decorationRight";
		items[1].x = 1535.4;
		items[1].y = 998.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"isPaperLayer":true});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_paperLayer.call(items[2] as ISceneCreatorSceneLayout_paperLayer);
		(items[2] as ISceneCreatorSceneLayout_paperLayer).isPaperLayer = true;
		items[2].x = 0;
		items[2].y = 0;
		items[2].width = 2048.00;
		items[2].height = 1536.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"slot":"character outfit"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_stotCharacter.call(items[3] as ISceneCreatorSceneLayout_stotCharacter);
		(items[3] as ISceneCreatorSceneLayout_stotCharacter).slot = "character outfit";
		items[3].x = 687.85;
		items[3].y = 1224.65;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"slot":"characterOther outfitOther"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_stotCharacterOther.call(items[4] as ISceneCreatorSceneLayout_stotCharacterOther);
		(items[4] as ISceneCreatorSceneLayout_stotCharacterOther).slot = "characterOther outfitOther";
		items[4].x = 1355.35;
		items[4].y = 1224.65;
		if (items[4].scale) items[4].scale.x = -1.000;
		if (items[4].scale) items[4].scale.y = 1.000;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"slot":"handItem"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_slotItem.call(items[5] as ISceneCreatorSceneLayout_slotItem);
		(items[5] as ISceneCreatorSceneLayout_slotItem).slot = "handItem";
		items[5].x = 839.15;
		items[5].y = 987.45;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function SceneCreatorSceneLayout_slotItem(this: ISceneCreatorSceneLayout_slotItem) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"broccoli:handItem"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_itemBroccoli.call(items[0] as ISceneCreatorSceneLayout_itemBroccoli);
		(items[0] as ISceneCreatorSceneLayout_itemBroccoli).option = "broccoli:handItem";
		items[0].x = 4;
		items[0].y = -259;
		items[0].width = 265.00;
		items[0].height = 267.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"feather:handItem"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_itemFeather.call(items[1] as ISceneCreatorSceneLayout_itemFeather);
		(items[1] as ISceneCreatorSceneLayout_itemFeather).option = "feather:handItem";
		items[1].x = 4;
		items[1].y = -244;
		items[1].width = 343.00;
		items[1].height = 240.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"flower:handItem"});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_itemFlower.call(items[2] as ISceneCreatorSceneLayout_itemFlower);
		(items[2] as ISceneCreatorSceneLayout_itemFlower).option = "flower:handItem";
		items[2].x = 11.7;
		items[2].y = -296.15;
		items[2].width = 284.00;
		items[2].height = 306.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"lollipop:handItem"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_itemLollipop.call(items[3] as ISceneCreatorSceneLayout_itemLollipop);
		(items[3] as ISceneCreatorSceneLayout_itemLollipop).option = "lollipop:handItem";
		items[3].x = 21.55;
		items[3].y = -250.15;
		items[3].width = 227.00;
		items[3].height = 256.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"teddyBear:handItem"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_itemTeddyBear.call(items[4] as ISceneCreatorSceneLayout_itemTeddyBear);
		(items[4] as ISceneCreatorSceneLayout_itemTeddyBear).option = "teddyBear:handItem";
		items[4].x = -20.1;
		items[4].y = -234.7;
		items[4].width = 260.00;
		items[4].height = 303.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"magicWand:handItem"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_itemWand.call(items[5] as ISceneCreatorSceneLayout_itemWand);
		(items[5] as ISceneCreatorSceneLayout_itemWand).option = "magicWand:handItem";
		items[5].x = 4;
		items[5].y = -237;
		items[5].width = 275.00;
		items[5].height = 245.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function SceneCreatorSceneLayout_itemBroccoli(this: ISceneCreatorSceneLayout_itemBroccoli) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-broccoli.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_itemFeather(this: ISceneCreatorSceneLayout_itemFeather) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-feather.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_itemFlower(this: ISceneCreatorSceneLayout_itemFlower) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-flower.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_itemLollipop(this: ISceneCreatorSceneLayout_itemLollipop) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-lollipop.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_itemTeddyBear(this: ISceneCreatorSceneLayout_itemTeddyBear) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-teddyBear.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_itemWand(this: ISceneCreatorSceneLayout_itemWand) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-magicWand.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_stotCharacter(this: ISceneCreatorSceneLayout_stotCharacter) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"xavier:character normal:outfit"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_xavierNormal.call(items[0] as ISceneCreatorSceneLayout_xavierNormal);
		(items[0] as ISceneCreatorSceneLayout_xavierNormal).option = "xavier:character normal:outfit";
		items[0].x = -249;
		items[0].y = -761;
		items[0].width = 498.00;
		items[0].height = 761.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"xavier:character space:outfit"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_xavierSpace.call(items[1] as ISceneCreatorSceneLayout_xavierSpace);
		(items[1] as ISceneCreatorSceneLayout_xavierSpace).option = "xavier:character space:outfit";
		items[1].x = -251;
		items[1].y = -794;
		items[1].width = 502.00;
		items[1].height = 794.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"xavier:character baseball:outfit"});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_xavierBaseball.call(items[2] as ISceneCreatorSceneLayout_xavierBaseball);
		(items[2] as ISceneCreatorSceneLayout_xavierBaseball).option = "xavier:character baseball:outfit";
		items[2].x = -210.7;
		items[2].y = -737;
		items[2].width = 451.00;
		items[2].height = 737.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"yadina:character normal:outfit"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_yadinaNormal.call(items[3] as ISceneCreatorSceneLayout_yadinaNormal);
		(items[3] as ISceneCreatorSceneLayout_yadinaNormal).option = "yadina:character normal:outfit";
		items[3].x = -285.1;
		items[3].y = -601;
		items[3].width = 585.00;
		items[3].height = 601.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"yadina:character space:outfit"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_yadinaSpace.call(items[4] as ISceneCreatorSceneLayout_yadinaSpace);
		(items[4] as ISceneCreatorSceneLayout_yadinaSpace).option = "yadina:character space:outfit";
		items[4].x = -303.3;
		items[4].y = -672;
		items[4].width = 577.00;
		items[4].height = 672.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"yadina:character baseball:outfit"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_yadinaBaseball.call(items[5] as ISceneCreatorSceneLayout_yadinaBaseball);
		(items[5] as ISceneCreatorSceneLayout_yadinaBaseball).option = "yadina:character baseball:outfit";
		items[5].x = -287.5;
		items[5].y = -615;
		items[5].width = 575.00;
		items[5].height = 615.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"brad:character normal:outfit"});
	}
	if (items[6]) {
		SceneCreatorSceneLayout_bradNormal.call(items[6] as ISceneCreatorSceneLayout_bradNormal);
		(items[6] as ISceneCreatorSceneLayout_bradNormal).option = "brad:character normal:outfit";
		items[6].x = -202.55;
		items[6].y = -687;
		items[6].width = 431.00;
		items[6].height = 687.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"brad:character space:outfit"});
	}
	if (items[7]) {
		SceneCreatorSceneLayout_bradSpace.call(items[7] as ISceneCreatorSceneLayout_bradSpace);
		(items[7] as ISceneCreatorSceneLayout_bradSpace).option = "brad:character space:outfit";
		items[7].x = -248.05;
		items[7].y = -748;
		items[7].width = 485.00;
		items[7].height = 748.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"brad:character baseball:outfit"});
	}
	if (items[8]) {
		SceneCreatorSceneLayout_bradBaseball.call(items[8] as ISceneCreatorSceneLayout_bradBaseball);
		(items[8] as ISceneCreatorSceneLayout_bradBaseball).option = "brad:character baseball:outfit";
		items[8].x = -215.9;
		items[8].y = -701;
		items[8].width = 454.00;
		items[8].height = 701.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function SceneCreatorSceneLayout_xavierNormal(this: ISceneCreatorSceneLayout_xavierNormal) {
	if (this.setLayoutTexture) this.setLayoutTexture("xavier-normal.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_xavierSpace(this: ISceneCreatorSceneLayout_xavierSpace) {
	if (this.setLayoutTexture) this.setLayoutTexture("xavier-space.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_xavierBaseball(this: ISceneCreatorSceneLayout_xavierBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("xavier-baseball.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_yadinaNormal(this: ISceneCreatorSceneLayout_yadinaNormal) {
	if (this.setLayoutTexture) this.setLayoutTexture("yadina-normal.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_yadinaSpace(this: ISceneCreatorSceneLayout_yadinaSpace) {
	if (this.setLayoutTexture) this.setLayoutTexture("yadina-space.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_yadinaBaseball(this: ISceneCreatorSceneLayout_yadinaBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("yadina-baseball.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_bradNormal(this: ISceneCreatorSceneLayout_bradNormal) {
	if (this.setLayoutTexture) this.setLayoutTexture("brad-normal.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_bradSpace(this: ISceneCreatorSceneLayout_bradSpace) {
	if (this.setLayoutTexture) this.setLayoutTexture("brad-space.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_bradBaseball(this: ISceneCreatorSceneLayout_bradBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("brad-baseball.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_stotCharacterOther(this: ISceneCreatorSceneLayout_stotCharacterOther) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"xavier:characterOther normal:outfitOther"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_xavierNormal.call(items[0] as ISceneCreatorSceneLayout_xavierNormal);
		(items[0] as ISceneCreatorSceneLayout_xavierNormal).option = "xavier:characterOther normal:outfitOther";
		items[0].x = -249;
		items[0].y = -761;
		items[0].width = 498.00;
		items[0].height = 761.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"xavier:characterOther space:outfitOther"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_xavierSpace.call(items[1] as ISceneCreatorSceneLayout_xavierSpace);
		(items[1] as ISceneCreatorSceneLayout_xavierSpace).option = "xavier:characterOther space:outfitOther";
		items[1].x = -251;
		items[1].y = -794;
		items[1].width = 502.00;
		items[1].height = 794.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"xavier:characterOther baseball:outfitOther"});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_xavierBaseball.call(items[2] as ISceneCreatorSceneLayout_xavierBaseball);
		(items[2] as ISceneCreatorSceneLayout_xavierBaseball).option = "xavier:characterOther baseball:outfitOther";
		items[2].x = -210.7;
		items[2].y = -737;
		items[2].width = 451.00;
		items[2].height = 737.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"yadina:characterOther normal:outfitOther"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_yadinaNormal.call(items[3] as ISceneCreatorSceneLayout_yadinaNormal);
		(items[3] as ISceneCreatorSceneLayout_yadinaNormal).option = "yadina:characterOther normal:outfitOther";
		items[3].x = -285.1;
		items[3].y = -601;
		items[3].width = 585.00;
		items[3].height = 601.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"yadina:characterOther space:outfitOther"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_yadinaSpace.call(items[4] as ISceneCreatorSceneLayout_yadinaSpace);
		(items[4] as ISceneCreatorSceneLayout_yadinaSpace).option = "yadina:characterOther space:outfitOther";
		items[4].x = -303.3;
		items[4].y = -672;
		items[4].width = 577.00;
		items[4].height = 672.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"yadina:characterOther baseball:outfitOther"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_yadinaBaseball.call(items[5] as ISceneCreatorSceneLayout_yadinaBaseball);
		(items[5] as ISceneCreatorSceneLayout_yadinaBaseball).option = "yadina:characterOther baseball:outfitOther";
		items[5].x = -287.5;
		items[5].y = -615;
		items[5].width = 575.00;
		items[5].height = 615.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"brad:characterOther normal:outfitOther"});
	}
	if (items[6]) {
		SceneCreatorSceneLayout_bradNormal.call(items[6] as ISceneCreatorSceneLayout_bradNormal);
		(items[6] as ISceneCreatorSceneLayout_bradNormal).option = "brad:characterOther normal:outfitOther";
		items[6].x = -202.55;
		items[6].y = -687;
		items[6].width = 431.00;
		items[6].height = 687.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"brad:characterOther space:outfitOther"});
	}
	if (items[7]) {
		SceneCreatorSceneLayout_bradSpace.call(items[7] as ISceneCreatorSceneLayout_bradSpace);
		(items[7] as ISceneCreatorSceneLayout_bradSpace).option = "brad:characterOther space:outfitOther";
		items[7].x = -248.05;
		items[7].y = -748;
		items[7].width = 485.00;
		items[7].height = 748.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"brad:characterOther baseball:outfitOther"});
	}
	if (items[8]) {
		SceneCreatorSceneLayout_bradBaseball.call(items[8] as ISceneCreatorSceneLayout_bradBaseball);
		(items[8] as ISceneCreatorSceneLayout_bradBaseball).option = "brad:characterOther baseball:outfitOther";
		items[8].x = -215.9;
		items[8].y = -701;
		items[8].width = 454.00;
		items[8].height = 701.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function SceneCreatorSceneLayout_paperLayer(this: ISceneCreatorSceneLayout_paperLayer) {
	return this;
}
function SceneCreatorSceneLayout_slotDecorationLeft(this: ISceneCreatorSceneLayout_slotDecorationLeft) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"statue:decorationLeft"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_decorationStatue.call(items[0] as ISceneCreatorSceneLayout_decorationStatue);
		(items[0] as ISceneCreatorSceneLayout_decorationStatue).option = "statue:decorationLeft";
		items[0].x = -411.5;
		items[0].y = -672;
		items[0].width = 424.00;
		items[0].height = 672.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"spookyTree:decorationLeft"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_decorationSpookyTree.call(items[1] as ISceneCreatorSceneLayout_decorationSpookyTree);
		(items[1] as ISceneCreatorSceneLayout_decorationSpookyTree).option = "spookyTree:decorationLeft";
		items[1].x = -459;
		items[1].y = -731;
		items[1].width = 747.00;
		items[1].height = 731.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"saturn:decorationLeft"});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_decorationSaturn.call(items[2] as ISceneCreatorSceneLayout_decorationSaturn);
		(items[2] as ISceneCreatorSceneLayout_decorationSaturn).option = "saturn:decorationLeft";
		items[2].x = -479.8;
		items[2].y = -601.6;
		items[2].width = 743.00;
		items[2].height = 432.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"satellite:decorationLeft"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_decorationSatellite.call(items[3] as ISceneCreatorSceneLayout_decorationSatellite);
		(items[3] as ISceneCreatorSceneLayout_decorationSatellite).option = "satellite:decorationLeft";
		items[3].x = -481;
		items[3].y = -624.6;
		items[3].width = 677.00;
		items[3].height = 455.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"plasticineCastle:decorationLeft"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_decorationPlasticineCastle.call(items[4] as ISceneCreatorSceneLayout_decorationPlasticineCastle);
		(items[4] as ISceneCreatorSceneLayout_decorationPlasticineCastle).option = "plasticineCastle:decorationLeft";
		items[4].x = -439.5;
		items[4].y = -658;
		items[4].width = 879.00;
		items[4].height = 658.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"hotAirBalloon:decorationLeft"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_decorationHotAirBalloon.call(items[5] as ISceneCreatorSceneLayout_decorationHotAirBalloon);
		(items[5] as ISceneCreatorSceneLayout_decorationHotAirBalloon).option = "hotAirBalloon:decorationLeft";
		items[5].x = -375;
		items[5].y = -727;
		items[5].width = 408.00;
		items[5].height = 567.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"garden:decorationLeft"});
	}
	if (items[6]) {
		SceneCreatorSceneLayout_decorationGarden.call(items[6] as ISceneCreatorSceneLayout_decorationGarden);
		(items[6] as ISceneCreatorSceneLayout_decorationGarden).option = "garden:decorationLeft";
		items[6].x = -473;
		items[6].y = -334;
		items[6].width = 946.00;
		items[6].height = 334.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"dragon:decorationLeft"});
	}
	if (items[7]) {
		SceneCreatorSceneLayout_decorationDragon.call(items[7] as ISceneCreatorSceneLayout_decorationDragon);
		(items[7] as ISceneCreatorSceneLayout_decorationDragon).option = "dragon:decorationLeft";
		items[7].x = -441;
		items[7].y = -752;
		items[7].width = 711.00;
		items[7].height = 752.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"castle:decorationLeft"});
	}
	if (items[8]) {
		SceneCreatorSceneLayout_decorationCastle.call(items[8] as ISceneCreatorSceneLayout_decorationCastle);
		(items[8] as ISceneCreatorSceneLayout_decorationCastle).option = "castle:decorationLeft";
		items[8].x = -492;
		items[8].y = -605;
		items[8].width = 984.00;
		items[8].height = 605.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"option":"books:decorationLeft"});
	}
	if (items[9]) {
		SceneCreatorSceneLayout_decorationBooks.call(items[9] as ISceneCreatorSceneLayout_decorationBooks);
		(items[9] as ISceneCreatorSceneLayout_decorationBooks).option = "books:decorationLeft";
		items[9].x = -494.5;
		items[9].y = -490;
		items[9].width = 989.00;
		items[9].height = 490.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"option":"boat:decorationLeft"});
	}
	if (items[10]) {
		SceneCreatorSceneLayout_decorationBoat.call(items[10] as ISceneCreatorSceneLayout_decorationBoat);
		(items[10] as ISceneCreatorSceneLayout_decorationBoat).option = "boat:decorationLeft";
		items[10].x = -501.8;
		items[10].y = -723;
		items[10].width = 1010.00;
		items[10].height = 723.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	return this;
}
function SceneCreatorSceneLayout_decorationStatue(this: ISceneCreatorSceneLayout_decorationStatue) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-statue.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationSpookyTree(this: ISceneCreatorSceneLayout_decorationSpookyTree) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-spookyTree.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationSaturn(this: ISceneCreatorSceneLayout_decorationSaturn) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-saturn.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationSatellite(this: ISceneCreatorSceneLayout_decorationSatellite) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-satellite.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationPlasticineCastle(this: ISceneCreatorSceneLayout_decorationPlasticineCastle) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-plasticineCastle.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationHotAirBalloon(this: ISceneCreatorSceneLayout_decorationHotAirBalloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-hotAirBalloon.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationGarden(this: ISceneCreatorSceneLayout_decorationGarden) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-garden.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationDragon(this: ISceneCreatorSceneLayout_decorationDragon) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-dragon.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationCastle(this: ISceneCreatorSceneLayout_decorationCastle) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-castle.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationBooks(this: ISceneCreatorSceneLayout_decorationBooks) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-books.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_decorationBoat(this: ISceneCreatorSceneLayout_decorationBoat) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-boat.png", 0.000, 0.000);
	return this;
}
function SceneCreatorSceneLayout_slotDecorationRight(this: ISceneCreatorSceneLayout_slotDecorationRight) {
	let items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"statue:decorationRight"});
	}
	if (items[0]) {
		SceneCreatorSceneLayout_decorationStatue.call(items[0] as ISceneCreatorSceneLayout_decorationStatue);
		(items[0] as ISceneCreatorSceneLayout_decorationStatue).option = "statue:decorationRight";
		items[0].x = 13.15;
		items[0].y = -672;
		items[0].width = 424.00;
		items[0].height = 672.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"spookyTree:decorationRight"});
	}
	if (items[1]) {
		SceneCreatorSceneLayout_decorationSpookyTree.call(items[1] as ISceneCreatorSceneLayout_decorationSpookyTree);
		(items[1] as ISceneCreatorSceneLayout_decorationSpookyTree).option = "spookyTree:decorationRight";
		items[1].x = -265.2;
		items[1].y = -731;
		items[1].width = 747.00;
		items[1].height = 731.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"saturn:decorationRight"});
	}
	if (items[2]) {
		SceneCreatorSceneLayout_decorationSaturn.call(items[2] as ISceneCreatorSceneLayout_decorationSaturn);
		(items[2] as ISceneCreatorSceneLayout_decorationSaturn).option = "saturn:decorationRight";
		items[2].x = -263.2;
		items[2].y = -601.6;
		items[2].width = 743.00;
		items[2].height = 432.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"satellite:decorationRight"});
	}
	if (items[3]) {
		SceneCreatorSceneLayout_decorationSatellite.call(items[3] as ISceneCreatorSceneLayout_decorationSatellite);
		(items[3] as ISceneCreatorSceneLayout_decorationSatellite).option = "satellite:decorationRight";
		items[3].x = -198.85;
		items[3].y = -624.6;
		items[3].width = 677.00;
		items[3].height = 455.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"plasticineCastle:decorationRight"});
	}
	if (items[4]) {
		SceneCreatorSceneLayout_decorationPlasticineCastle.call(items[4] as ISceneCreatorSceneLayout_decorationPlasticineCastle);
		(items[4] as ISceneCreatorSceneLayout_decorationPlasticineCastle).option = "plasticineCastle:decorationRight";
		items[4].x = -439.5;
		items[4].y = -658;
		items[4].width = 879.00;
		items[4].height = 658.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"hotAirBalloon:decorationRight"});
	}
	if (items[5]) {
		SceneCreatorSceneLayout_decorationHotAirBalloon.call(items[5] as ISceneCreatorSceneLayout_decorationHotAirBalloon);
		(items[5] as ISceneCreatorSceneLayout_decorationHotAirBalloon).option = "hotAirBalloon:decorationRight";
		items[5].x = 24;
		items[5].y = -727;
		items[5].width = 408.00;
		items[5].height = 567.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"garden:decorationRight"});
	}
	if (items[6]) {
		SceneCreatorSceneLayout_decorationGarden.call(items[6] as ISceneCreatorSceneLayout_decorationGarden);
		(items[6] as ISceneCreatorSceneLayout_decorationGarden).option = "garden:decorationRight";
		items[6].x = -473;
		items[6].y = -334;
		items[6].width = 946.00;
		items[6].height = 334.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"dragon:decorationRight"});
	}
	if (items[7]) {
		SceneCreatorSceneLayout_decorationDragon.call(items[7] as ISceneCreatorSceneLayout_decorationDragon);
		(items[7] as ISceneCreatorSceneLayout_decorationDragon).option = "dragon:decorationRight";
		items[7].x = -270;
		items[7].y = -752;
		items[7].width = 711.00;
		items[7].height = 752.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"option":"castle:decorationRight"});
	}
	if (items[8]) {
		SceneCreatorSceneLayout_decorationCastle.call(items[8] as ISceneCreatorSceneLayout_decorationCastle);
		(items[8] as ISceneCreatorSceneLayout_decorationCastle).option = "castle:decorationRight";
		items[8].x = -492;
		items[8].y = -605;
		items[8].width = 984.00;
		items[8].height = 605.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"option":"books:decorationRight"});
	}
	if (items[9]) {
		SceneCreatorSceneLayout_decorationBooks.call(items[9] as ISceneCreatorSceneLayout_decorationBooks);
		(items[9] as ISceneCreatorSceneLayout_decorationBooks).option = "books:decorationRight";
		items[9].x = -494.5;
		items[9].y = -490;
		items[9].width = 989.00;
		items[9].height = 490.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"option":"boat:decorationRight"});
	}
	if (items[10]) {
		SceneCreatorSceneLayout_decorationBoat.call(items[10] as ISceneCreatorSceneLayout_decorationBoat);
		(items[10] as ISceneCreatorSceneLayout_decorationBoat).option = "boat:decorationRight";
		items[10].x = -501.8;
		items[10].y = -723;
		items[10].width = 1010.00;
		items[10].height = 723.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	return this;
}
interface ISceneCreatorSceneLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ISceneCreatorSceneLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ISceneCreatorSceneLayoutSprite extends ISceneCreatorSceneLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ISceneCreatorSceneLayoutText extends ISceneCreatorSceneLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ISceneCreatorSceneLayoutPolygon extends ISceneCreatorSceneLayoutArray<{x:number,y:number}> {
}
interface ISceneCreatorSceneLayout {
	readonly sceneDefault: ISceneCreatorSceneLayout_sceneDefault;
}
interface ISceneCreatorSceneLayout_sceneDefault extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_slotDecorationLeft|ISceneCreatorSceneLayout_slotDecorationRight|ISceneCreatorSceneLayout_paperLayer|ISceneCreatorSceneLayout_stotCharacter|ISceneCreatorSceneLayout_stotCharacterOther|ISceneCreatorSceneLayout_slotItem>;
}
interface ISceneCreatorSceneLayout_slotItem extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_itemBroccoli|ISceneCreatorSceneLayout_itemFeather|ISceneCreatorSceneLayout_itemFlower|ISceneCreatorSceneLayout_itemLollipop|ISceneCreatorSceneLayout_itemTeddyBear|ISceneCreatorSceneLayout_itemWand>;
	slot: string;
}
interface ISceneCreatorSceneLayout_itemBroccoli extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_itemFeather extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_itemFlower extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_itemLollipop extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_itemTeddyBear extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_itemWand extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_stotCharacter extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_xavierNormal|ISceneCreatorSceneLayout_xavierSpace|ISceneCreatorSceneLayout_xavierBaseball|ISceneCreatorSceneLayout_yadinaNormal|ISceneCreatorSceneLayout_yadinaSpace|ISceneCreatorSceneLayout_yadinaBaseball|ISceneCreatorSceneLayout_bradNormal|ISceneCreatorSceneLayout_bradSpace|ISceneCreatorSceneLayout_bradBaseball>;
	slot: string;
}
interface ISceneCreatorSceneLayout_xavierNormal extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_xavierSpace extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_xavierBaseball extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_yadinaNormal extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_yadinaSpace extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_yadinaBaseball extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_bradNormal extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_bradSpace extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_bradBaseball extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_stotCharacterOther extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_xavierNormal|ISceneCreatorSceneLayout_xavierSpace|ISceneCreatorSceneLayout_xavierBaseball|ISceneCreatorSceneLayout_yadinaNormal|ISceneCreatorSceneLayout_yadinaSpace|ISceneCreatorSceneLayout_yadinaBaseball|ISceneCreatorSceneLayout_bradNormal|ISceneCreatorSceneLayout_bradSpace|ISceneCreatorSceneLayout_bradBaseball>;
	slot: string;
}
interface ISceneCreatorSceneLayout_paperLayer extends ISceneCreatorSceneLayoutContainer {
	isPaperLayer: boolean;
}
interface ISceneCreatorSceneLayout_slotDecorationLeft extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_decorationStatue|ISceneCreatorSceneLayout_decorationSpookyTree|ISceneCreatorSceneLayout_decorationSaturn|ISceneCreatorSceneLayout_decorationSatellite|ISceneCreatorSceneLayout_decorationPlasticineCastle|ISceneCreatorSceneLayout_decorationHotAirBalloon|ISceneCreatorSceneLayout_decorationGarden|ISceneCreatorSceneLayout_decorationDragon|ISceneCreatorSceneLayout_decorationCastle|ISceneCreatorSceneLayout_decorationBooks|ISceneCreatorSceneLayout_decorationBoat>;
	slot: string;
}
interface ISceneCreatorSceneLayout_decorationStatue extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationSpookyTree extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationSaturn extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationSatellite extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationPlasticineCastle extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationHotAirBalloon extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationGarden extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationDragon extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationCastle extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationBooks extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_decorationBoat extends ISceneCreatorSceneLayoutSprite {
	option: string;
}
interface ISceneCreatorSceneLayout_slotDecorationRight extends ISceneCreatorSceneLayoutContainer {
	readonly items: ISceneCreatorSceneLayoutArray<ISceneCreatorSceneLayout_decorationStatue|ISceneCreatorSceneLayout_decorationSpookyTree|ISceneCreatorSceneLayout_decorationSaturn|ISceneCreatorSceneLayout_decorationSatellite|ISceneCreatorSceneLayout_decorationPlasticineCastle|ISceneCreatorSceneLayout_decorationHotAirBalloon|ISceneCreatorSceneLayout_decorationGarden|ISceneCreatorSceneLayout_decorationDragon|ISceneCreatorSceneLayout_decorationCastle|ISceneCreatorSceneLayout_decorationBooks|ISceneCreatorSceneLayout_decorationBoat>;
	slot: string;
}
